import type { IsoYear } from '../../types/iso-date';

/**
 * Checks whether the given string is a valid 4-digit ISO year (YYYY).
 *
 * Accepts 0000 through 9999.
 * Returns true with a branded type guard on success, false otherwise.
 */
export function isIsoYear(str: string): str is IsoYear {
  return /^\d{4}$/.test(str);
}

